const customerId = Shopify.customer?.id; // Shopify.liquid file se customer id

// 🎯 Save Wishlist
async function saveWishlist(wishlistData) {
  try {
    await fetch('https://wallart.yogendra-maxcode.workers.dev/wishlist/save', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId, wishlist: wishlistData })
    });
    console.log('Wishlist saved!');
  } catch (error) {
    console.error('Error saving wishlist:', error);
  }
}

// 🎯 Get Wishlist
async function getWishlist() {
  try {
    const response = await fetch('https://wallart.yogendra-maxcode.workers.dev/wishlist/get', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId })
    });
    const data = await response.json();
    console.log('Wishlist loaded:', data.wishlist);
    return data.wishlist;
  } catch (error) {
    console.error('Error getting wishlist:', error);
    return [];
  }
}

// Example usage:
// saveWishlist([{productId: 1234, variantId: 5678}]);
// getWishlist();
